
// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useState,
// } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   fetchScheduledEvents,
//   formatEventType,
//   getStatusBadgeClass,
//   getEventTypeIcon,
// } from "../../services/eventsApi";
// import MediaGrid from "../media/MediaGrid";
// import AppFooter from "../AppFooter";
// import {
//   FaArrowLeft,
//   FaPlus,
//   FaSync,
//   FaEye,
// } from "react-icons/fa";
// import "./ScheduledEventsList.css";

// /**
//  * Helper to safely format dates coming back from MySQL/Node.
//  */
// function formatDate(value) {
//   if (!value) return "—";
//   try {
//     const d = new Date(value);
//     if (Number.isNaN(d.getTime())) {
//       return String(value);
//     }
//     return d.toLocaleString();
//   } catch {
//     return String(value);
//   }
// }

// /**
//  * Helper to format date in short format for embedded display
//  * Shows date only without time
//  */
// function formatDateShort(value) {
//   if (!value) return "—";
//   try {
//     const d = new Date(value);
//     if (Number.isNaN(d.getTime())) {
//       return String(value);
//     }
//     // Format as "Jan 11, 2026"
//     return d.toLocaleDateString(undefined, { 
//       month: 'short', 
//       day: 'numeric',
//       year: 'numeric'
//     });
//   } catch {
//     return String(value);
//   }
// }

// /**
//  * Helper to format date range for events
//  * In embedded mode, shows compact date range
//  */
// function formatDateRange(startDate, endDate, compact = false) {
//   if (!startDate && !endDate) return "—";
  
//   if (compact) {
//     // Compact format for embedded mode
//     const start = startDate ? formatDateShort(startDate) : "—";
//     const end = endDate ? formatDateShort(endDate) : "—";
    
//     if (startDate && endDate) {
//       const startD = new Date(startDate);
//       const endD = new Date(endDate);
      
//       // If same day, show only start date
//       if (startD.toDateString() === endD.toDateString()) {
//         return start;
//       }
      
//       // If same year, omit year from start date
//       if (startD.getFullYear() === endD.getFullYear()) {
//         const startShort = startD.toLocaleDateString(undefined, { 
//           month: 'short', 
//           day: 'numeric'
//         });
//         return `${startShort} - ${end}`;
//       }
//     }
    
//     return `${start} - ${end}`;
//   }
  
//   // Full format for standalone mode
//   const start = startDate ? formatDate(startDate) : "—";
//   const end = endDate ? formatDate(endDate) : "—";
  
//   if (startDate && endDate) {
//     const startD = new Date(startDate);
//     const endD = new Date(endDate);
    
//     // If same day, show only start date
//     if (startD.toDateString() === endD.toDateString()) {
//       return start;
//     }
//   }
  
//   return `${start} - ${end}`;
// }

// /**
//  * Parse MySQL-ish datetime safely.
//  */
// function parseDateMaybeMySQL(value) {
//   if (!value) return null;

//   if (value instanceof Date) {
//     return Number.isNaN(value.getTime()) ? null : value;
//   }

//   const raw = String(value);
//   const normalized =
//     /\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(raw) && !raw.includes("T")
//       ? raw.replace(" ", "T")
//       : raw;

//   const d = new Date(normalized);
//   if (!Number.isNaN(d.getTime())) return d;

//   const fallback = new Date(raw);
//   return Number.isNaN(fallback.getTime()) ? null : fallback;
// }

// /**
//  * Compare at "date" granularity (local day start)
//  */
// function toLocalDayStart(dateLike) {
//   const d = parseDateMaybeMySQL(dateLike);
//   if (!d) return null;
//   return new Date(d.getFullYear(), d.getMonth(), d.getDate());
// }

// /**
//  * ScheduledEventsList Component
//  * 
//  * @param {number} tenantId - Tenant ID (can be passed as prop or from route)
//  * @param {boolean} embedded - If true, renders in Dashboard mode (only auctions/raffles, no media, no footer)
//  * @param {string} filterType - Optional filter for specific event type
//  */
// export default function ScheduledEventsList({
//   tenantId: tenantIdProp,
//   embedded = false,
//   filterType = null,
// }) {
//   const { tenant: tenantFromRoute } = useParams();
//   const navigate = useNavigate();

//   // Resolve numeric tenantId – same pattern as ScheduledPostsList:
//   // Number(:tenant) || 1 as a fallback.
//   const tenantId = useMemo(
//     () => Number(tenantIdProp ?? tenantFromRoute) || 1,
//     [tenantIdProp, tenantFromRoute]
//   );

//   const [events, setEvents] = useState([]);
//   const [pagination, setPagination] = useState({
//     total: 0,
//     // NOTE: embedded view *displays* 3, but we may fetch more to keep the list filled after filtering.
//     limit: embedded ? 25 : 50,
//     offset: 0,
//     hasMore: false,
//   });
//   const [loading, setLoading] = useState(false);
//   const [loadingMore, setLoadingMore] = useState(false);
//   const [error, setError] = useState("");

//   // Choose a wrapper class:
//   // - Standalone: Bootstrap container
//   // - Embedded: slim wrapper that fits nicely in Dashboard card cell
//   const wrapperClass = embedded
//     ? "dashboard-scheduled-events-container"
//     : "container py-3";

//   /**
//    * Cutoff = (today + 1 day) at local day granularity.
//    * Same logic as ScheduledPostsList for consistency.
//    */
//   const cutoffDay = useMemo(() => {
//     const now = new Date();
//     return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
//   }, []);

//   /**
//    * Core loader – can load the first page or append "load more" pages.
//    */
//   const loadPage = useCallback(
//     async ({ append = false, offsetOverride } = {}) => {
//       if (!tenantId) return;

//       // Dashboard (embedded) should DISPLAY 3, but we FETCH more to survive filtering.
//       const limit = embedded ? 25 : 50;
//       const offset =
//         offsetOverride ??
//         (append ? pagination.offset + limit : 0);

//       if (append) {
//         setLoadingMore(true);
//       } else {
//         setLoading(true);
//       }
//       setError("");

//       try {
//         const data = await fetchScheduledEvents(
//           tenantId,
//           { 
//             limit, 
//             offset,
//             type: filterType,
//           }
//         );

//         const nextEvents = Array.isArray(data?.events)
//           ? data.events
//           : [];

//         const nextPagination = data?.pagination || {
//           total: nextEvents.length,
//           limit,
//           offset,
//           hasMore: false,
//         };

//         setEvents((prev) =>
//           append ? [...prev, ...nextEvents] : nextEvents
//         );
//         setPagination(nextPagination);
//       } catch (err) {
//         console.error(
//           "Failed to load scheduled events",
//           err
//         );
//         setError(
//           err?.message || "Failed to load scheduled events."
//         );
//       } finally {
//         setLoading(false);
//         setLoadingMore(false);
//       }
//     },
//     [tenantId, pagination.offset, filterType, embedded]
//   );

//   // Initial load + reload when tenant changes
//   useEffect(() => {
//     loadPage({ append: false, offsetOverride: 0 });
//   }, [tenantId, filterType]);

//   /**
//    * DASHBOARD FILTERING (embedded mode only)
//    * CRITICAL: Filter for ONLY auctions and raffles in embedded mode
//    * - Uses type to show only auctions and raffles
//    * - Uses status to hide "not active" items
//    * - Uses end date for visibility cutoff
//    */
//   const visibleEvents = useMemo(() => {
//     if (!embedded) return events;

//     // REQUIREMENT: In embedded mode, ONLY show auctions and raffles
//     const allowedTypes = new Set(["auction", "raffle"]);
//     const allowedStatuses = new Set(["new", "active"]);

//     const filtered = (events || []).filter((evt) => {
//       if (!evt) return false;

//       const typeLower = String(evt.type || "").toLowerCase().trim();
//       const statusLower = String(evt.status || "").toLowerCase().trim();

//       // CRITICAL FILTER: Only auctions and raffles (no regular events, challenges, contests, etc.)
//       if (!allowedTypes.has(typeLower)) return false;

//       // Filter: only NEW or ACTIVE status
//       if (statusLower && !allowedStatuses.has(statusLower)) return false;

//       // Check end date for visibility
//       const endCandidate = evt.end_at ?? evt.endDate ?? evt.endAt ?? null;
//       const endDay = toLocalDayStart(endCandidate);
      
//       // If there's no end date, show it (it's actively scheduled)
//       if (!endDay) return true;

//       // Show only if endDay > (today + 1)
//       return endDay > cutoffDay;
//     });

//     // Dashboard should show only 3 items after filtering
//     return filtered.slice(0, 3);
//   }, [events, embedded, cutoffDay]);

//   /**
//    * Navigate to the appropriate detail page based on event type
//    * For auctions and raffles, navigate to action page
//    * For other events, navigate to event detail page
//    */
//   const handleOpen = (event) => {
//     if (!event) return;

//     const { type, id, eventId, eventItemId } = event;

//     // Determine navigation path based on event type
//     let path = "";

//     // IMPORTANT: Auctions and raffles should go to action page
//     if (type === "auction") {
//       path = `/${tenantFromRoute || tenantId}/event/${eventId}/item/${eventItemId}/action?type=auction&auctionId=${id}`;
//     } else if (type === "raffle") {
//       path = `/${tenantFromRoute || tenantId}/event/${eventId}/item/${eventItemId}/action?type=raffle&raffleId=${id}`;
//     } else if (type === "event") {
//       // Regular event - go to event detail
//       path = `/${tenantFromRoute || tenantId}/${eventId}/eventDetail`;
//     } else if (eventItemId) {
//       // Event with item (other event types) - go to event item detail
//       path = `/${tenantFromRoute || tenantId}/${eventId}/${eventItemId}/eventItemDetail`;
//     } else if (eventId) {
//       // Event without item - go to event detail
//       path = `/${tenantFromRoute || tenantId}/${eventId}/eventDetail`;
//     } else {
//       // Fallback - try to go somewhere reasonable
//       console.warn("Unclear navigation for event:", event);
//       path = `/${tenantFromRoute || tenantId}/events`;
//     }

//     navigate(path);
//   };

//   const onRefresh = useCallback(() => {
//     loadPage({ append: false, offsetOverride: 0 });
//   }, [loadPage]);

//   const onLoadMore = useCallback(() => {
//     loadPage({ append: true });
//   }, [loadPage]);

//   /**
//    * Navigate to standalone ScheduledEventsList to view all events
//    */
//   const handleViewAll = () => {
//     navigate(`/${tenantFromRoute || tenantId}/events/scheduled-events`);
//   };

//   const hasVisibleEvents = visibleEvents.length > 0;

//   return (
//     <div className={wrapperClass}>
//       {/* Header */}
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <div>
//           <h5 className="mb-0">
//             {filterType
//               ? `Scheduled ${formatEventType(filterType)}s`
//               : "Scheduled Events"}
//           </h5>
//           {!embedded && <small className="text-muted">Tenant #{tenantId}</small>}
//         </div>

//         {/* Optional refresh button - only in standalone mode */}
//         {!embedded && (
//           <button
//             type="button"
//             className="btn btn-outline-secondary btn-sm"
//             onClick={onRefresh}
//             disabled={loading}
//           >
//             <FaSync className={loading ? "fa-spin me-1" : "me-1"} />
//             Refresh
//           </button>
//         )}
//       </div>

//       {/* Error banner */}
//       {!!error && (
//         <div className="alert alert-danger" role="alert">
//           <strong>Error:</strong> {error}
//         </div>
//       )}

//       {/* Loading state */}
//       {loading && !hasVisibleEvents && (
//         <div className="text-center text-muted py-4">
//           Loading scheduled events…
//         </div>
//       )}

//       {/* Empty state */}
//       {!loading && !hasVisibleEvents && !error && (
//         <div className="text-center text-muted py-4">
//           {embedded
//             ? "No active auctions or raffles."
//             : "No scheduled events found for this tenant."}
//         </div>
//       )}

//       {/* Scheduled events list */}
//       {hasVisibleEvents && (
//         <div className="list-group mb-3">
//           {visibleEvents.map((event) => {
//             const media =
//               event.files && Array.isArray(event.files) ? event.files : [];

//             const status = String(event.status || "").toLowerCase();
//             const type = String(event.type || "").toLowerCase();
            
//             // Get appropriate display labels and classes
//             const typeDisplay = type === 'auction' ? 'AUCTION' : type === 'raffle' ? 'RAFFLE' : formatEventType(event.type);
//             const badgeClass = getStatusBadgeClass(status);
//             const iconClass = getEventTypeIcon(event.type);

//             // Get event name
//             const displayName = event.name || "Unnamed Event";

//             // Get date range - use compact format for embedded mode
//             const dateRange = formatDateRange(
//               event.start_at || event.startDate,
//               event.end_at || event.endDate,
//               embedded // compact mode for embedded
//             );

//             // Get event/item names with fallbacks for standalone mode
//             const eventName =
//               event.eventName ||
//               (event.type === "event" ? event.name : null) ||
//               (event.eventId ? `Event #${event.eventId}` : null);

//             const itemName =
//               event.itemName || (event.eventItemId ? `Item #${event.eventItemId}` : null);

//             return (
//               <div
//                 key={`${event.type}-${event.id}`}
//                 className="list-group-item mb-2 rounded shadow-sm"
//                 data-event-type={event.type}
//                 style={{ cursor: "pointer" }}
//                 onClick={() => handleOpen(event)}
//               >
//                 {/* EMBEDDED MODE: Compact layout matching requirements */}
//                 {embedded && (
//                   <>
//                     {/* 
//                       REQUIREMENT: Layout structure
//                       Row 1: Event name (left) | Status badge (right)
//                       Row 2: Date range (left) | Type badge (AUCTION/RAFFLE) (right)
//                     */}
//                     <div className="d-flex justify-content-between align-items-start mb-1">
//                       <div className="flex-grow-1">
//                         {/* Event name */}
//                         <strong className="d-block mb-1">{displayName}</strong>
//                         {/* Date range below name - REQUIREMENT */}
//                         <small className="text-muted d-block">
//                           {dateRange}
//                         </small>
//                       </div>

//                       <div className="d-flex flex-column align-items-end gap-1">
//                         {/* Status badge on top - REQUIREMENT */}
//                         <span className={`badge ${badgeClass} text-uppercase`}>
//                           {status}
//                         </span>
                        
//                         {/* Type badge (AUCTION/RAFFLE) below status - REQUIREMENT */}
//                         <span className={`badge ${type === 'auction' ? 'bg-warning text-dark' : 'bg-info'} text-uppercase`}>
//                           {typeDisplay}
//                         </span>
//                       </div>
//                     </div>
//                   </>
//                 )}

//                 {/* STANDALONE MODE: Full layout with all details */}
//                 {!embedded && (
//                   <>
//                     {/* Top row: event info + status */}
//                     <div className="d-flex justify-content-between mb-1">
//                       <div className="flex-grow-1">
//                         <div className="d-flex align-items-center gap-2 mb-1">
//                           <i className={`fas ${iconClass}`} title={typeDisplay}></i>
//                           <strong>{displayName}</strong>
//                           <span className={`badge ${badgeClass} text-uppercase`}>
//                             {typeDisplay}
//                           </span>
//                         </div>
//                         <small className="text-muted d-block">
//                           <i className="fas fa-clock me-1"></i>
//                           {dateRange}
//                         </small>

//                         {/* Event / item names (or fallback labels) - only show in standalone mode */}
//                         {(eventName || itemName) && event.type !== "event" && (
//                           <div className="small text-muted">
//                             {eventName}
//                             {itemName ? ` • ${itemName}` : ""}
//                           </div>
//                         )}
//                       </div>

//                       <div className="d-flex flex-column align-items-end">
//                         <span className={`badge ${badgeClass} text-uppercase`}>
//                           {status}
//                         </span>
//                       </div>
//                     </div>

//                     {/* Description snippet – ONLY in full (non-embedded) view */}
//                     {event.description && (
//                       <p className="mb-2 text-muted small">
//                         {event.description.length > 150
//                           ? event.description.slice(0, 150) + "…"
//                           : event.description}
//                       </p>
//                     )}

//                     {/* Media thumbnails – ONLY in full (non-embedded) view */}
//                     {!!media.length && (
//                       <div className="mb-2">
//                         <MediaGrid items={media} />
//                       </div>
//                     )}
//                   </>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {/* "View All" button - only shown in embedded mode when there are visible events */}
//       {embedded && hasVisibleEvents && (
//         <div className="text-center mb-3">
//           <button
//             type="button"
//             className="btn btn-primary btn-sm"
//             onClick={handleViewAll}
//           >
//             <FaEye className="me-1" />
//             View All Scheduled Events
//           </button>
//         </div>
//       )}

//       {/* Pagination - only in standalone mode */}
//       {!embedded && pagination.hasMore && (
//         <div className="text-center mb-3">
//           <button
//             type="button"
//             className="btn btn-outline-secondary btn-sm"
//             onClick={onLoadMore}
//             disabled={loadingMore}
//           >
//             {loadingMore ? "Loading…" : "Load more"}
//           </button>
//         </div>
//       )}

//       {/* Footer – keep existing behavior for standalone views.
//           In embedded mode (Dashboard) we hide this so you don't get a nested footer. */}
//       {!embedded && (
//         <AppFooter
//           buttons={[
//             {
//               icon: <FaArrowLeft />,
//               label: "Back",
//               onClick: () => navigate(-1),
//             },
//             {
//               icon: <FaPlus />,
//               label: "Add Event",
//               onClick: () => navigate(`/${tenantFromRoute || tenantId}/eventAdd`),
//             },
//           ]}
//         />
//       )}
//     </div>
//   );
// }


// client/src/components/event/ScheduledEventsList.jsx
/**
 * Scheduled Events List Component
 * 
 * Displays upcoming/active auctions and raffles in embedded Dashboard mode
 * Shows all event types in standalone mode
 * 
 * REQUIREMENTS:
 * 1. Embedded mode: ONLY shows auctions and raffles (filters out regular events)
 * 2. Layout: Event name | Status badge (top), Date range | Type badge (bottom)
 * 3. Maintains same size as original
 * 4. Preserves all existing functionality (navigation, error handling, loading states)
 * 
 * Works with scheduledEventsRoute-SIMPLIFIED.js backend that queries ONLY t_auction and t_raffle
 */

import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FaArrowLeft,
  FaPlus,
  FaSync,
  FaEye,
} from "react-icons/fa";
import "./ScheduledEventsList.css";

/**
 * Helper to safely format dates coming back from MySQL/Node.
 */
function formatDate(value) {
  if (!value) return "—";
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) {
      return String(value);
    }
    return d.toLocaleString();
  } catch {
    return String(value);
  }
}

/**
 * Helper to format date in short format for embedded display
 * Shows date only without time
 */
function formatDateShort(value) {
  if (!value) return "—";
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) {
      return String(value);
    }
    // Format as "Jan 11, 2026"
    return d.toLocaleDateString(undefined, { 
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    });
  } catch {
    return String(value);
  }
}

/**
 * Helper to format date range for events
 * In embedded mode, shows compact date range
 */
function formatDateRange(startDate, endDate, compact = false) {
  if (!startDate && !endDate) return "—";
  
  if (compact) {
    // Compact format for embedded mode
    const start = startDate ? formatDateShort(startDate) : "—";
    const end = endDate ? formatDateShort(endDate) : "—";
    
    if (startDate && endDate) {
      const startD = new Date(startDate);
      const endD = new Date(endDate);
      
      // If same day, show only start date
      if (startD.toDateString() === endD.toDateString()) {
        return start;
      }
      
      // If same year, omit year from start date
      if (startD.getFullYear() === endD.getFullYear()) {
        const startShort = startD.toLocaleDateString(undefined, { 
          month: 'short', 
          day: 'numeric'
        });
        return `${startShort} - ${end}`;
      }
    }
    
    return `${start} - ${end}`;
  }
  
  // Full format for standalone mode
  const start = startDate ? formatDate(startDate) : "—";
  const end = endDate ? formatDate(endDate) : "—";
  
  if (startDate && endDate) {
    const startD = new Date(startDate);
    const endD = new Date(endDate);
    
    // If same day, show only start date
    if (startD.toDateString() === endD.toDateString()) {
      return start;
    }
  }
  
  return `${start} - ${end}`;
}

/**
 * Parse MySQL-ish datetime safely.
 */
function parseDateMaybeMySQL(value) {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value);
  const normalized =
    /\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(raw) && !raw.includes("T")
      ? raw.replace(" ", "T")
      : raw;

  const d = new Date(normalized);
  if (!Number.isNaN(d.getTime())) return d;

  const fallback = new Date(raw);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
}

/**
 * Compare at "date" granularity (local day start)
 */
function toLocalDayStart(dateLike) {
  const d = parseDateMaybeMySQL(dateLike);
  if (!d) return null;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/**
 * Get status badge class based on status
 */
function getStatusBadgeClass(status) {
  const statusLower = String(status || "").toLowerCase();
  switch (statusLower) {
    case 'new': return 'bg-secondary';
    case 'active': return 'bg-success';
    case 'complete': case 'completed': return 'bg-dark';
    case 'cancelled': return 'bg-danger';
    default: return 'bg-secondary';
  }
}

/**
 * ScheduledEventsList Component
 * 
 * @param {number} tenantId - Tenant ID (can be passed as prop or from route)
 * @param {boolean} embedded - If true, renders in Dashboard mode (only auctions/raffles, no media, no footer)
 * @param {string} filterType - Optional filter for specific event type
 */
export default function ScheduledEventsList({
  tenantId: tenantIdProp,
  embedded = false,
  filterType = null,
}) {
  const { tenant: tenantFromRoute } = useParams();
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL || '';

  // Resolve numeric tenantId
  const tenantId = useMemo(
    () => Number(tenantIdProp ?? tenantFromRoute) || 1,
    [tenantIdProp, tenantFromRoute]
  );

  const [events, setEvents] = useState([]);
  const [pagination, setPagination] = useState({
    total: 0,
    limit: embedded ? 25 : 50,
    offset: 0,
    hasMore: false,
  });
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState("");

  // Choose a wrapper class based on mode
  // const wrapperClass = embedded
  //   ? "dashboard-scheduled-events-container"
  //   : "container py-3";
  const wrapperClass = embedded
  ? "dashboard-scheduled-events-container scheduled-events-theme"
  : "container py-3 scheduled-events-list-container scheduled-events-theme";

  /**
   * Cutoff = (today + 1 day) at local day granularity.
   */
  const cutoffDay = useMemo(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  }, []);

  /**
   * Core loader – fetches data from /api/events/:tenant/scheduled-events
   * This endpoint is handled by scheduledEventsRoute-SIMPLIFIED.js which queries ONLY t_auction and t_raffle
   */
  const loadPage = useCallback(
    async ({ append = false, offsetOverride } = {}) => {
      if (!tenantId) return;

      // Dashboard (embedded) should DISPLAY 3, but we FETCH more to survive filtering.
      const limit = embedded ? 25 : 50;
      const offset =
        offsetOverride ??
        (append ? pagination.offset + limit : 0);

      if (append) {
        setLoadingMore(true);
      } else {
        setLoading(true);
      }
      setError("");

      try {
        // Call the simplified route: /api/events/:tenant/scheduled-events
        // This route returns ONLY auctions and raffles from t_auction and t_raffle tables
        const response = await axios.get(
          `${baseUrl}/api/events/${tenantId}/scheduled-events`,
          { 
            params: { 
              limit, 
              offset,
              ...(filterType && { type: filterType })
            }
          }
        );

        const data = response.data;
        const nextEvents = Array.isArray(data?.events) ? data.events : [];
        const nextPagination = data?.pagination || {
          total: nextEvents.length,
          limit,
          offset,
          hasMore: false,
        };

        setEvents((prev) =>
          append ? [...prev, ...nextEvents] : nextEvents
        );
        setPagination(nextPagination);
      } catch (err) {
        console.error(
          "[ScheduledEventsList] Failed to load scheduled events:",
          err
        );
        setError(
          err?.response?.data?.message || err?.message || "Failed to load scheduled events."
        );
      } finally {
        setLoading(false);
        setLoadingMore(false);
      }
    },
    [tenantId, pagination.offset, filterType, embedded, baseUrl]
  );

  // Initial load + reload when tenant changes
  useEffect(() => {
    loadPage({ append: false, offsetOverride: 0 });
  }, [tenantId, filterType]);

  /**
   * DASHBOARD FILTERING (embedded mode only)
   * CRITICAL: Filter for ONLY auctions and raffles in embedded mode
   * Note: The backend route already returns ONLY auctions and raffles,
   * but we add additional client-side filtering for status and end date
   */
  const visibleEvents = useMemo(() => {
    if (!embedded) return events;

    // In embedded mode, apply additional filters
    const allowedTypes = new Set(["auction", "raffle"]);
    const allowedStatuses = new Set(["new", "active"]);

    const filtered = (events || []).filter((evt) => {
      if (!evt) return false;

      const typeLower = String(evt.type || "").toLowerCase().trim();
      const statusLower = String(evt.status || "").toLowerCase().trim();

      // Double-check type (backend should already filter, but be safe)
      if (!allowedTypes.has(typeLower)) return false;

      // Filter: only NEW or ACTIVE status
      if (statusLower && !allowedStatuses.has(statusLower)) return false;

      // Check end date for visibility
      const endCandidate = evt.endDate ?? evt.end_at ?? evt.endAt ?? null;
      const endDay = toLocalDayStart(endCandidate);
      
      // If there's no end date, show it (it's actively scheduled)
      if (!endDay) return true;

      // Show only if endDay > (today + 1)
      return endDay >= cutoffDay;
    });

    // Dashboard should show only 3 items after filtering
    return filtered.slice(0, 3);
  }, [events, embedded, cutoffDay]);

  /**
   * Navigate to the appropriate detail page based on event type
   * For auctions and raffles, navigate to action page
   */
  const handleOpen = (event) => {
    if (!event) return;

    const { type, id, eventId, eventItemId } = event;

    // Determine navigation path based on event type
    let path = "";

    // IMPORTANT: Auctions and raffles should go to action page
    if (type === "auction") {
      path = `/${tenantFromRoute || tenantId}/event/${eventId}/item/${eventItemId}/action?type=auction&auctionId=${id}`;
    } else if (type === "raffle") {
      path = `/${tenantFromRoute || tenantId}/event/${eventId}/item/${eventItemId}/action?type=raffle&raffleId=${id}`;
    } else if (eventItemId) {
      // Event with item - go to event item detail
      path = `/${tenantFromRoute || tenantId}/${eventId}/${eventItemId}/eventItemDetail`;
    } else if (eventId) {
      // Event without item - go to event detail
      path = `/${tenantFromRoute || tenantId}/${eventId}/eventDetail`;
    } else {
      // Fallback
      console.warn("[ScheduledEventsList] Unclear navigation for event:", event);
      path = `/${tenantFromRoute || tenantId}/events`;
    }

    navigate(path);
  };

  const onRefresh = useCallback(() => {
    loadPage({ append: false, offsetOverride: 0 });
  }, [loadPage]);

  const onLoadMore = useCallback(() => {
    loadPage({ append: true });
  }, [loadPage]);

  /**
   * Navigate to standalone ScheduledEventsList to view all events
   */
  const handleViewAll = () => {
    navigate(`/${tenantFromRoute || tenantId}/events/scheduled-events`);
  };

  const hasVisibleEvents = visibleEvents.length > 0;

  return (
    <div className={wrapperClass}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Scheduled Events</h5>
          {!embedded && <small className="text-muted">Tenant #{tenantId}</small>}
        </div>

        {/* Optional refresh button - only in standalone mode */}
        {!embedded && (
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={onRefresh}
            disabled={loading}
          >
            <FaSync className={loading ? "fa-spin me-1" : "me-1"} />
            Refresh
          </button>
        )}
      </div>

      {/* Error banner */}
      {!!error && (
        <div className="alert alert-danger" role="alert">
          <strong>Error:</strong> {error}
        </div>
      )}

      {/* Loading state */}
      {loading && !hasVisibleEvents && (
        <div className="text-center text-muted py-4">
          Loading scheduled events…
        </div>
      )}

      {/* Empty state */}
      {!loading && !hasVisibleEvents && !error && (
        <div className="text-center text-muted py-4">
          {embedded
            ? "No active auctions or raffles."
            : "No scheduled events found for this tenant."}
        </div>
      )}

      {/* Scheduled events list */}
      {hasVisibleEvents && (
        <div className="list-group mb-3">
          {visibleEvents.map((event) => {
            const status = String(event.status || "").toLowerCase();
            const type = String(event.type || "").toLowerCase();
            
            // Get appropriate display labels and classes
            const typeDisplay = type === 'auction' ? 'AUCTION' : type === 'raffle' ? 'RAFFLE' : type.toUpperCase();
            const badgeClass = getStatusBadgeClass(status);

            // Get event name
            const displayName = event.name || "Unnamed Event";

            // Get date range - use compact format for embedded mode
            const dateRange = formatDateRange(
              event.startDate || event.start_at,
              event.endDate || event.end_at,
              embedded // compact mode for embedded
            );

            const topLineLabel = event.eventName
              ? (event.itemName ? `${event.eventName} • ${event.itemName}` : event.eventName)
              : (event.itemName ? `${displayName} • ${event.itemName}` : displayName);

            return (
              <div
                key={`${event.type}-${event.id}`}
                className="list-group-item mb-2 rounded shadow-sm"
                data-event-type={event.type}
                style={{ cursor: "pointer" }}
                onClick={() => handleOpen(event)}
              >
                {/* EMBEDDED MODE: Compact layout matching requirements */}
                {/* {embedded && (
                  <>
                    <div className="d-flex justify-content-between align-items-start mb-1">
                      <div className="flex-grow-1">
                        <strong className="d-block mb-1">{displayName}</strong>
                        <small className="text-muted d-block">
                          {dateRange}
                        </small>
                      </div>

                      <div className="d-flex flex-column align-items-end gap-1">
                        <span className={`badge ${badgeClass} text-uppercase`}>
                          {status}
                        </span>
                        
                        <span className={`badge ${type === 'auction' ? 'bg-warning text-dark' : 'bg-info'} text-uppercase`}>
                          {typeDisplay}
                        </span>
                      </div>
                    </div>

                    {event.eventName && (
                      <small className="text-muted d-block mt-1">
                        <i className="fas fa-calendar me-1"></i>
                        {event.eventName}
                        {event.itemName && ` › ${event.itemName}`}
                      </small>
                    )}
                  </>
                )} */}

                {embedded && (
                  <>
                    {/* 
                      REQUIREMENT: Layout structure
                      Row 1: Event name + item name (left) | Status badge (right)
                      Row 2: Date range (left) | Type badge (AUCTION/RAFFLE) (right)
                      NOTE: Left side is CLAMPED to 2 lines total.
                    */}
                    <div className="d-flex justify-content-between align-items-start mb-1">
                      {/* LEFT: exactly 2 lines (title + date), left aligned */}
                      <div className="flex-grow-1 os-event-left">
                        <strong className="os-event-title">{topLineLabel}</strong>

                        <span className="os-event-date">
                          {dateRange}
                        </span>
                      </div>

                      {/* RIGHT: badges unchanged */}
                      <div className="d-flex flex-column align-items-end gap-1">
                        {/* Status badge on top - REQUIREMENT */}
                        <span className={`badge ${badgeClass} text-uppercase`}>
                          {status}
                        </span>

                        {/* Type badge (AUCTION/RAFFLE) below status - REQUIREMENT */}
                        <span
                          className={`badge ${
                            type === "auction" ? "bg-warning text-dark" : "bg-info"
                          } text-uppercase`}
                        >
                          {typeDisplay}
                        </span>
                      </div>
                    </div>
                  </>
                )}


                {/* STANDALONE MODE: Full layout with all details */}
                {!embedded && (
                  <>
                    <div className="d-flex justify-content-between mb-1">
                      <div className="flex-grow-1">
                        <strong className="d-block mb-1">{displayName}</strong>
                        <small className="text-muted d-block">
                          <i className="fas fa-clock me-1"></i>
                          {dateRange}
                        </small>

                        {/* Event / item names */}
                        {event.eventName && (
                          <div className="small text-muted">
                            {event.eventName}
                            {event.itemName ? ` • ${event.itemName}` : ""}
                          </div>
                        )}
                      </div>

                      <div className="d-flex flex-column align-items-end gap-1">
                        <span className={`badge ${badgeClass} text-uppercase`}>
                          {status}
                        </span>
                        <span className={`badge ${type === 'auction' ? 'bg-warning text-dark' : 'bg-info'} text-uppercase`}>
                          {typeDisplay}
                        </span>
                      </div>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* "View All" button - only shown in embedded mode when there are visible events */}
      {embedded && hasVisibleEvents && (
        <div className="text-center mb-3">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleViewAll}
          >
            <FaEye className="me-1" />
            View All Scheduled Events
          </button>
        </div>
      )}

      {/* Pagination - only in standalone mode */}
      {!embedded && pagination.hasMore && (
        <div className="text-center mb-3">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={onLoadMore}
            disabled={loadingMore}
          >
            {loadingMore ? "Loading…" : "Load more"}
          </button>
        </div>
      )}

      {/* Footer - only in standalone mode */}
      {!embedded && (
        <div className="mt-4">
          <button
            className="btn btn-outline-secondary me-2"
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft className="me-1" />
            Back
          </button>
          <button
            className="btn btn-primary"
            onClick={() => navigate(`/${tenantFromRoute || tenantId}/eventAdd`)}
          >
            <FaPlus className="me-1" />
            Add Event
          </button>
        </div>
      )}
    </div>
  );
}